const initialState = {
    activeSlideIndex: 0,
    nSlides: 0,
    canScrollNext: true,
    canScrollPrev: true,
    scrollProgress: 0,
    loop: false,
    direction: "ltr",
    axis: "x",
    draggable: false,
    carouselId: "",
};
export function initializeState(initialArg) {
    return { ...initialState, ...initialArg };
}
//# sourceMappingURL=state.js.map